export default "__VITE_ASSET__691e2894__"